import { Typography } from 'antd';
import * as React from 'react';
const { Text } = Typography;

export interface LabeledTextProps {
  label: string;
  text?: string;
}

export function LabeledText(props: LabeledTextProps) {
  return (
    <div className="labeled-date">
      <Text type="secondary">{props.label}: </Text>
      <Text strong>{props.text}</Text>
    </div>
  );
}
